import ApiService from "../infra/ApiService";
import TableNotes from "../utils/TableNotes";

const actions = {
  setSelectedDataFromSped({ commit }, selectedDataFromSped) {
    const table = new TableNotes();
    const data = table.spedNotes(selectedDataFromSped);
    commit("SET_SELECTED_DATA_FROM_SPED", data);
  },
  setExpandedNote({ commit }, note) {
    commit("SET_EXPANDED_NOTE", note);
  },
  setSeletedItensFromSPED({ commit }, seletedItensFromSPED) {
    commit("SET_ITENS_FROM_SPED", seletedItensFromSPED);
  },
  setSeletedItensFromXML({ commit }, seletedItensFromXML) {
    commit("SET_ITENS_FROM_XML", seletedItensFromXML);
  },
  setIsReferencing({ commit }, { idNfe, cProd }) {
    commit("SET_ITEM_TO_REFERENCING", { idNfe, cProd });
  },
  setItemXMLReference({ commit }, productInfo) {
    commit("REMOVE_REFERENCE", productInfo);
  },
  async removeReference(
    { commit, getters, rootGetters, dispatch },
    { idNfe, cProd },
    messages,
  ) {
    commit("SET_NOTE_TO_CALCULATING", { idNfe, cProd });
    const apiService = new ApiService(messages);
    const itensToRemoveReference = getters
      .getReferencedItems(idNfe)
      .filter((item) => item.cProd === cProd);
    await Promise.all(
      itensToRemoveReference.map(async (item) =>
        apiService.deleteReference(item, rootGetters.getCompany.id),
      ),
    );
    commit("REMOVE_REFERENCE", { idNfe, cProd });
    commit("SET_VL_APURATION_ON_NF", {
      idNfe,
      totalNote: getters.getTotalApuredByNote(idNfe),
    });
    await dispatch("saveIcmsValue", { idNfe, messages });
    commit("SET_NOTE_TO_CALCULATING", { idNfe, cProd });
  },
  async calculateStAndPob(
    { commit, getters, rootGetters, dispatch },
    { idNfe, cProd },
    messages,
  ) {
    commit("SET_NOTE_TO_CALCULATING", { idNfe, cProd });
    const apiService = new ApiService(messages);
    const hasItemNoCalculated = getters
      .getReferencedItems(idNfe)
      .filter((item) => !item.vlStApured);
    const apuration = await Promise.all(
      hasItemNoCalculated.map(async (item) =>
        apiService.getCalcIcmsSt(item, rootGetters.getCompany.id),
      ),
    );
    commit("SET_VL_APURATION_ON_ITEMS", { idNfe, apuration });
    commit("SET_VL_APURATION_ON_NF", {
      idNfe,
      totalNote: getters.getTotalApuredByNote(idNfe),
    });
    await dispatch("saveIcmsValue", { idNfe, messages });
    commit("SET_NOTE_TO_CALCULATING", { idNfe, cProd });
  },
  async saveIcmsValue({ getters, rootGetters }, { idNfe, messages }) {
    const [{ cpfCnpj, numDoc, ser, codMod }] = getters.getNoteById(idNfe);
    const { vlIcmsDar, vlPobreza } = getters.getTotalApuredByNote(idNfe);
    const value = {
      idEmpresa: rootGetters.getCompany.id,
      cpfCnpj,
      numDoc,
      ser,
      codMod,
      vlIcmsDar,
      vlPobreza,
    };
    const apiService = new ApiService(messages);
    await apiService.insertStApured(value);
  },
  setIsCalculating({ commit }, idNfe) {
    commit("SET_NOTE_TO_CALCULATING", idNfe);
  },
};

export default actions;
